module.exports = __webpack_public_path__ + "static/optimize-img-3-f7a05a946fe5f46bf4ac42b61796deae.jpg";